import React from "react";
import { Route, Redirect, withRouter } from "react-router-dom";
import { useSelector } from "react-redux";
const PRoute = ({ component: RouteComponent, ...rest }) => {
  const isUserAuthenticated = useSelector(
    (state) => state.auth.isAuthenticated
  );
  const isToken = useSelector((state) => state.auth.isToken);
  return (
    <Route
      {...rest}
      render={(routeProps) =>
        !!isUserAuthenticated && !!isToken ? (
          <RouteComponent {...routeProps} />
        ) : (
          <Redirect to={"/"} />
        )
      }
    />
  );
};
const AdminPrivateRoute = ({ component: RouteComponent, ...rest }) => {
  // Check the admin authentication and token
  const isAdminAuthenticated = useSelector(
    (state) => state.admin.isAuthenticated
  );
  const isAdminToken = useSelector((state) => state.admin.isToken);
  return (
    <Route
      {...rest}
      render={(routeProps) =>
        !!isAdminAuthenticated && !!isAdminToken ? (
          <RouteComponent {...routeProps} />
        ) : (
          <Redirect to={"/admin"} />
        )
      }
    />
  );
};
let PrivateRoute = withRouter(PRoute);
export default withRouter(AdminPrivateRoute);
export { PrivateRoute }